export * from './private-header.component'
